import { useKestrel } from 'features/kestrelViewer'
import { PhotoReelTooltip } from 'features/kestrelViewer/tutorial/components/PhotoReelTooltip'
import { SidebarTooltip } from 'features/kestrelViewer/tutorial/components/SidebarTooltip'
import {
  getAnnotationTools,
  getSecondToolset,
  getSettingsTools,
} from 'features/kestrelViewer/tutorial/constants'
import { useGeckoPermissions } from 'features/permissions'
import { PERMISSION_GECKO_INTERNAL_MEMBER } from 'types'

import { ControlsDialog } from './components/ControlsDialog'
import { SettingsTooltip } from './components/SettingsTooltip'
import { ToolbarTooltipsWrapper } from './components/ToolbarTooltipsWrapper'
import {
  BgCover,
  ExitTutorialButton,
  TutorialOverlay,
  TutorialStepCounter,
} from './components/TutorialStyledComponents'
import { ViewTooltip } from './components/ViewTooltip'
import { WelcomeDialog } from './components/WelcomeDialog'
import { useKestrelTutorialContext } from './KestrelTutorialContext'

const WELCOME_INDEX = 0
const CONTROLS_INDEX = 1
const VIEW_INDEX = 2
const ANNOTATION_TOOLS_INDEX = 3
const SIDEBAR_INDEX = 4
const PHOTOREEL_TOOLS_INDEX = 5
const PHOTOREEL_INDEX = 6
const SETTINGS_TOOLS_INDEX = 7
const SETTINGS_INDEX = 8

export const KestrelTutorial = () => {
  const {
    tutorialIndex: index,
    setTutorialIndex: setIndex,
    setShowTutorial,
  } = useKestrelTutorialContext()
  const { gatekeeper, kestrelModel } = useKestrel()
  const { hasPermissions } = useGeckoPermissions()
  const hasPrimitiveBuilderPermission = hasPermissions([
    PERMISSION_GECKO_INTERNAL_MEMBER,
  ])
  const photosEnabled = Boolean(
    kestrelModel?.id && kestrelModel?.data.photosEnabled
  )

  const handleNext = () => {
    // on last index finish tutorial
    if (index === SETTINGS_INDEX) {
      setShowTutorial(false)
    } else {
      if (!photosEnabled && index === PHOTOREEL_INDEX - 1) {
        setIndex(PHOTOREEL_INDEX + 1)
      } else {
        setIndex(index + 1)
      }
    }
  }

  const handlePrevious = () => {
    if (!photosEnabled && index === PHOTOREEL_INDEX + 1) {
      setIndex(PHOTOREEL_INDEX - 1)
    } else {
      setIndex(index - 1)
    }
  }

  const handleSkip = () => {
    setShowTutorial(false)
  }

  return (
    <>
      {(index === WELCOME_INDEX ||
        index === CONTROLS_INDEX ||
        index === SIDEBAR_INDEX ||
        index === PHOTOREEL_INDEX ||
        index === SETTINGS_INDEX) && <BgCover />}
      <TutorialStepCounter>
        Step {index + 1}/{SETTINGS_INDEX + 1}
      </TutorialStepCounter>
      <ExitTutorialButton onClick={() => setShowTutorial(false)}>
        Exit Tutorial
      </ExitTutorialButton>
      <TutorialOverlay>
        {index === WELCOME_INDEX ? (
          <WelcomeDialog onNext={handleNext} onSkip={handleSkip} />
        ) : index === CONTROLS_INDEX ? (
          <ControlsDialog onNext={handleNext} onPrevious={handlePrevious} />
        ) : index === VIEW_INDEX ? (
          <ViewTooltip onNext={handleNext} onPrevious={handlePrevious} />
        ) : index === ANNOTATION_TOOLS_INDEX ? (
          <ToolbarTooltipsWrapper
            tools={getAnnotationTools(gatekeeper)}
            onPrevious={handlePrevious}
            onNext={handleNext}
          />
        ) : index === SIDEBAR_INDEX ? (
          <SidebarTooltip onPrevious={handlePrevious} onNext={handleNext} />
        ) : index === PHOTOREEL_TOOLS_INDEX ? (
          <ToolbarTooltipsWrapper
            tools={getSecondToolset(
              gatekeeper,
              hasPrimitiveBuilderPermission,
              photosEnabled
            )}
            onPrevious={handlePrevious}
            onNext={handleNext}
          />
        ) : index === PHOTOREEL_INDEX ? (
          <PhotoReelTooltip onPrevious={handlePrevious} onNext={handleNext} />
        ) : index === SETTINGS_TOOLS_INDEX ? (
          <ToolbarTooltipsWrapper
            tools={getSettingsTools(
              gatekeeper,
              hasPrimitiveBuilderPermission,
              photosEnabled
            )}
            onPrevious={handlePrevious}
            onNext={handleNext}
          />
        ) : index === SETTINGS_INDEX ? (
          <SettingsTooltip onNext={handleNext} onPrevious={handlePrevious} />
        ) : null}
      </TutorialOverlay>
    </>
  )
}
